import { Component, OnInit } from '@angular/core';
import { ContactService } from 'src/app/services/contact.service';
import { ContactResponse, ContactRequest } from 'src/app/models/contact/contact.model';
import { Utilities } from 'src/app/services/core/utilities';

@Component({
  selector: 'app-becomePartner',
  templateUrl: './become-partner.component.html',
  styleUrls: ['./become-partner.component.css']
})
export class BecomePartnerComponent implements OnInit {

  contactResponse: ContactResponse;  
  modelContactUs: any = {};
  isSubmitClicked: boolean;
  isSuccess: boolean;
  constructor(private contactService: ContactService) { }

  ngOnInit() {
    this.isSubmitClicked = false;
    this.isSuccess = false;
  }

  private onDataLoadFailed(error: any): void {
    console.log(error);
  }

  private sendMail(result: ContactResponse): void {

    if (result.IsSuccess) {
      this.isSubmitClicked = false;
      this.isSuccess = true;
      setTimeout(() => {
        this.isSuccess = false;
      }, 2000);
    }
  }
  sendMailContact(): void {
    this.isSubmitClicked = true;
    this.isSuccess = false;
    var contactRequest = new ContactRequest(Utilities.Email);
    contactRequest.Subject = "Become a partner";
    contactRequest.HtmlContent = document.getElementById("become_partner_details").innerHTML;
    this.contactService.sendEmail(contactRequest).subscribe(result => this.sendMail(result), error => this.onDataLoadFailed(error));

  }
}
